var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{attrs:{"label":"Étape"}},[_c('el-select',{attrs:{"value":_vm.value,"clearable":""},on:{"change":_vm.onValueChange}},_vm._l((_vm.Steps),function(step){return _c('el-option',{key:step.key,attrs:{"label":step.label,"value":step.key}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }